import { Component, ViewChild, ChangeDetectorRef, HostListener, ElementRef, Renderer2, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { StorageService } from '../../../Common/services/storage.service';
import { GinfoObjectiveGoalsComponent } from '../projects/ginfo-objective-goals/ginfo-objective-goals.component';
import { RefTypeEnum } from '../../enums/ref-type-enum';
import { ProjectService } from '../../services/project.service';
import { PurposeEnum } from '../../enums/purpose-enum';
import { Activity, Agency, FundingAndRMS, GinfoKeyDatesVm, GinfoObjectiveGoalsVm, GinfoProjectDetailsVm, InstructionsVM, ProductListManualVm, ProjectActivity, ProjectAttachement, ProjectAttachmentFilesVm, ProjectCost, ProjectFilesVm, ProjectGeneralInfoVm, ProjectMaterial, ProjectStatus, ProjectVm, GinfoObjectiveProjectRMSVm, ProjectTemplateInstructionsVm, ProjectInstructionsVM, InstallationProductResultDto, StoreValidationRequestVM, ReviewLog } from '../../models/project-vm';
import { UserLogin } from '../../../Common/models/user.login';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GinfoProjectDetailsComponent } from '../projects/ginfo-project-details/ginfo-project-details.component';
import { CommonStoreListComponent } from '../common/common-store-list/common-store-list.component';
import { CommonProductListManualComponent } from '../common/common-product-list-manual/common-product-list-manual.component';
import { CommonProductsListComponent } from '../common/common-products-list/common-products-list.component';
import { ProjectConstants } from '../../constants/component-messages';
import { MessageService } from '../../services/message.service';
import { projectObjectiveDTO } from '../../models/ProjectObjective';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment.development';
import { ProjectApprovalStage, RoleKey, WizardStatus, RoleName, ActionItems, EmailPurpose } from '../../../Common/Constants/common.constants';
import { CommonApprovalComponent } from '../common-approval/common-approval.component';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { UserRoleServiceService } from '../../../shared/services/user-role-service.service';
import { ErrorLoggerService } from '../../../shared/services/error-logger.service';
import { FundingRmsComponent } from '../projects/funding-rms/funding-rms.component';
import { CustomEncodeDecodeService } from '../../../Common/services/custom-encode-decode.service';
import { BaseFileHandler } from '../common/base-file-handler';
import * as XLSX from 'xlsx';
//import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import { finalize, Subscription } from 'rxjs';
import { MaterialRMSConstants, NewlyAddedProductsConstants, ValidationCriteriaConstants, ApprovalConstants } from '../../../Common/Constants/data';
import { ConfirmationService } from 'primeng/api';
import { MasterService } from '../../../administration/services/master.service';
import { Product } from '../../../administration/models/models-vm';
import { constants } from 'fs/promises';
import { GinfoKeyDatesComponent } from '../projects/ginfo-key-dates/ginfo-key-dates.component';
import { log } from 'console';
import { ProjectValidationCriteria } from '../../models/projectvalidationcriteria';
import { UnsavedChangesService } from '../../../unsaved-changes.service';
import { CanComponentDeactivate } from '../../../Common/guards/unsaved-changes.guard';
import { EmailRequestDto, ProjectDto } from '../../../Common/models/emailrequestdto';
import { EmailNotificationService } from '../../../Common/services/email-notification.service';



@Component({
  selector: 'app-addproject',
  templateUrl: './addproject.component.html',
  //styleUrl: './addproject.component.css',
  styleUrls: [
    './addproject.component.css'
    , './../../../../assets/css/new-project.css'
    , './../../../../assets/css/steps.css'
  ]
})
export class AddprojectComponent extends BaseFileHandler<Blob, File> implements OnInit, CanComponentDeactivate {
  showCommonProductsListManualComponent: boolean = false;
  showDeleteRMSIcon: boolean = false;
  displayBubbleStatus: any = {
    Approval_step: ''
    , ExecutionCompleted_step: ''
    , ExecutionStarted_step: ''
    , Initiated_step: ''
    , PWRLinked_step: ''
    , Verified_step: ''
  };
  @ViewChild('fileInputs') fileInputs!: ElementRef;
  @ViewChild('saveDiv') saveDiv!: ElementRef;
  vendorId?: string;
  override refType: RefTypeEnum = RefTypeEnum.Project;
  purposeStore: PurposeEnum = PurposeEnum.Stores;
  purposeAttachments: PurposeEnum = PurposeEnum.Attachments;
  purposeProducts: PurposeEnum = PurposeEnum.Products;
  storedVendorId: any;
  sreSPOCID: number = 0;
  //selectedCategory : number = 0;
  userDisplayName: string | null = "";
  selectedItemId: number | undefined;

  categoryList: any[] | undefined = [];
  categoryId?: string;
  storeFile: File | null | undefined;
  productFile: File | null | undefined;
  projectModel: ProjectVm = new ProjectVm();
  //projectObjectMaterialModel: projectObjectiveMaterial = new projectObjectiveMaterial();
  projectAttachmentFile: ProjectAttachmentFilesVm = new ProjectAttachmentFilesVm;
  projectAttachmentFiles: ProjectAttachmentFilesVm[] = [];
  projectAttachments: ProjectAttachement[] = [];
  projectId: number = 0;
  catgId: number = 0;
  enableApproval: boolean = false;
  initiatedClass: string = "step first";
  reciveCoomunication: any = {};
  //materials: Item[] = []; // Array to hold materials dropdown items
  //attachments: AttachmentsItem[] = [];
  selectedObjectives: any[] = [];
  mstMaterials: any[] = [];
  distinctMaterials: any[] = [];
  //private wordFileUrl: string = 'C:\Users\Dell\Downloads\dTRM-dTSCR Changes Design Document.docx';
  activities: Activity[] = [];
  //projectActivities: ActivitiesItems[] = [];
  selectedObjectIds: any = [];
  storesCount: number = 0;
  isRMSSelected: boolean = true;
  isShopCommSelected: boolean = true;
  thirdPartyAgencies: Agency[] = [];
  agency: Agency | null | undefined;
  agencyName?: string = "";
  agencyId: number | undefined;
  uInfo: UserLogin | null | undefined;
  enablePWR: boolean = false;
  override disableAfterReview: boolean = false;
  activeTab: string = 'generalInfo';
  shippingDate: Date | null | undefined;
  ShopComDataUrl: string = "";
  totalNumberOfStoresUploaded?: number;
  isShopComButtonVisible: boolean = false;
  minDate: Date;
  override disableAll: boolean = false;
  lockscreenForCS: boolean = false;
  projectTitleDisplay: string = ProjectConstants.PROJECT_TITLE;
  selectedCategories: any[] = [];
  previousSelectedCategories: any[] = [];
  selectedNewProductCategoryId?: number | null | undefined;
  orgProductsList: Product[] = [];
  allCategories: number[] = [];
  productItems: any[] = [];
  @ViewChild(GinfoProjectDetailsComponent) childComponent: GinfoProjectDetailsComponent | undefined;
  @ViewChild(CommonStoreListComponent) storeListComponent: CommonStoreListComponent | undefined;
  @ViewChild(CommonProductsListComponent) productsListComponent: CommonProductsListComponent | undefined;
  @ViewChild(CommonProductListManualComponent) productsListManualComponent: CommonProductListManualComponent | undefined;
  @ViewChild(CommonApprovalComponent) commonApprovalComponent: CommonApprovalComponent | undefined;
  @ViewChild(FundingRmsComponent) fundingRmsComponent: FundingRmsComponent | undefined;
  @ViewChild(GinfoKeyDatesComponent) ginfoKeyDatesComponent: GinfoKeyDatesComponent | undefined;
  isValidationCriteria: boolean = false;
  catgIds: number[] = [];
  isProjectModeDecided: boolean = false;
  hasProductItems: boolean = false;
  productReviewedDate: Date | null | undefined;
  productReviewedBy: string = '';
  newEstimationCost: number = 0;
  hasUnsaved: boolean = false;
  isPageLoad: boolean = false;
  existingManualStoreNumbersList?: string | null;

  public isITAdmin: boolean = false;
  public isSRETeam: boolean = false;
  public isSRESupport: boolean = false;
  public isCustomerSupportTeam: boolean = false;

  storesByStates: any[] = [];
  existingStoreNumbers?: string | null;
  validatedStoreNumbers?: string | null;
  selectedStoresByStates: any[] = [];

  showModalPopupForStates: boolean = false;
  isNotifiedForStoreIdentificaion: boolean = false;
  selectedIdentifiedStoreNumbers?: string = '';
  storeNumbersToIdentify?: string = '';

  constructor(override storageService: StorageService,
    override projectService: ProjectService,
    override toastr: ToastrService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private msgService: MessageService,
    private userRoleService: UserRoleServiceService,
    private errorLogService: ErrorLoggerService,
    private http: HttpClient, private cdr: ChangeDetectorRef,
    private datepipe: DatePipe,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private encodeDecodeService: CustomEncodeDecodeService,
    private confirmService: ConfirmationService, private masterService: MasterService,
    private unsavedChangesService: UnsavedChangesService,
    private emailService: EmailNotificationService
  ) {
    super(projectService, storageService, toastr);
    this.projectModel = new ProjectVm();
    this.minDate = new Date();
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this.unsavedChangesService.hasUnsaved) {
      $event.returnValue = 'You have unsaved changes! Are you sure you want to leave?';
    }
  }
  canDeactivate(): boolean {
    if (this.unsavedChangesService.hasUnsaved) {
      return confirm('You have unsaved changes! Are you sure you want to discard them?');
    }
    return true;
  }
  ngOnDestroy() {
    this.unsavedChangesService.setUnsavedChanges(false); // Reset when the component is destroyed
  }
  navigateAway() {
    if (this.canDeactivate()) {
      this.router.navigate(['/another-route']);
    }
  }
  onAnyFieldValueChange(e: boolean) {
    if (e) {
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  async ngOnInit() {
    this.isPageLoad = true;
    this.unsavedChangesService.getUnsavedChanges$().subscribe((hasUnsaved) => {
      this.hasUnsaved = hasUnsaved;
    });
    if (this.userRoleService.role?.roleKey == RoleKey.ITAdmin) {
      this.router.navigate(['/unauthorized']);
      return;
    }

    this.loadProducts();
    this.getAllActivities();
    this.getAllMaterials();
    this.addRMSItem();
    this.storedVendorId = this.storageService.getItem<any>("selectedVendor");
    this.vendorId = this.storedVendorId.vendorID;

    this.getStoresByStates();

    let encodedVal = localStorage.getItem('UserRoleInfo');
    if (encodedVal != null) {
      this.uInfo = JSON.parse(atob(encodedVal));

      let userRoleInfo: UserLogin = this.uInfo!;
      this.isITAdmin = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.ITAdmin);
      this.isSRETeam = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SREAdmin || a.roleName == RoleName.SRESupport) && (a.write == true));
      this.isSRESupport = userRoleInfo.roles.some((a: any) => (a.roleName == RoleName.SRESupport) && (a.write == false));
      this.isCustomerSupportTeam = userRoleInfo.roles.some((a: any) => a.roleName == RoleName.CustomerTeam);
    }
    this.categoryList = this.userRoleService.role?.roleID == 4 ? this.uInfo!.userCategory : this.uInfo!.categories;
    this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));

    this.route.params.subscribe(async params => {

      this.projectId = this.encodeDecodeService.decodeToInt(params['id']);
      const catIdString = this.encodeDecodeService.decode(params['catId']);
      if (catIdString) {
        this.catgIds = catIdString.split(',').map((id: any) => parseInt(id, 10));
      }

      if (this.projectId == 0) {
        if (this.userRoleService.role?.write == false) {
          this.router.navigate(['/unauthorized']);
          return;
        }
      }

      //role based enable disable
      if (this.projectId > 0) {
        if (this.userRoleService.role?.write === false) {
          this.disableAll = true;
        } else {
          if (this.userRoleService.role?.roleKey == RoleKey.CustomerTeam && this.catgIds && this.catgIds && this.catgIds.length > 0) {
            this.categoryList = this.uInfo!.categories;
            this.categoryList = this.categoryList.map((x: any) => ({ 'label': x.categoryName, 'value': x.categoryID }));
            this.selectedCategories = this.categoryList.map(a => a.value);
            this.disableAll = this.userRoleService.disableField(this.catgIds);
          }
        }
        //role based enable disable end

        this.ngxService.start();

        await this.loadProjectDetails(this.projectId);
      }
      else {
        this.addMaterialItem();
        this.addAttachmentsItem();
        this.isValidationCriteria = true;
        this.isProjectModeDecided = true;
      }

      this.projectModel.projectStatus = new ProjectStatus();
      this.projectModel.projectStatus.changedBy = this.uInfo?.userID;
      this.projectModel.projectStatus.changedDate = new Date();
      this.projectModel.projectStatus.isApproved = false;
      this.projectModel.projectStatus.refID = 0;
      this.projectModel.projectStatus.statusID = 1;
      this.projectModel.projectStatus.type = RefTypeEnum.Project;

      this.enablePWR
        = ((this.projectModel.projectStatus!.statusID! > 1
          && this.projectModel.projectApproval?.approvalStage == ApprovalConstants.Approval_Approved)
          || (this.projectModel.projectStatus!.statusID! > 2)) ?
          (this.uInfo!.roles[0].roleID == 2 || (this.uInfo!.roles[0].roleID == 3 && this.uInfo!.roles[0].write == true) ? true : false) :
          false;

      if ((this.projectModel.projectApproval == null)
      ) {
        this.disableAfterReview = false;
      }

      this.loadDefaultDataMapping();
      // this.setActiveTabOnScroll();
      // Setting initial active tab directly
      this.activeTab = 'generalInfo';
      this.setMinDate();

    });
    //this.categoryList = this.storageService.getItem<UserLogin>("UserInfo");
  }

  private getAllActivities() {
    this.projectService.getAllActivities().subscribe(x => {
      this.activities = x;
    });
  }

  private getAllMaterials() {
    this.projectService.getAllMaterials().subscribe(x => {
      this.mstMaterials = x;
      this.filterDistinctMaterials();
    });
  }

  filterDistinctMaterials() {
    const materialMap = new Map<number, any>();
    this.mstMaterials.forEach(material => {
      if (!materialMap.has(material.materialType)) {
        materialMap.set(material.materialType, material);
      }
    });
    this.distinctMaterials = Array.from(materialMap.values());
  }

  onRmsSelect(event: any) {

    this.isRMSSelected = false;
    this.isShopCommSelected = true;
    this.projectModel.generalInfo.projectDetails.shopCommItemNumber = '';
  }

  onShopCommSelect(event: any) {

    this.isShopCommSelected = false;
    this.isRMSSelected = true;
    this.projectModel.generalInfo.projectDetails.rmsNumber = '';
  }

  onDirectToStoreSelect(event: any) {
    this.isShopCommSelected = true;
    this.isRMSSelected = true;
    this.projectModel.generalInfo.projectDetails.rmsNumber = '';
    this.projectModel.generalInfo.projectDetails.shopCommItemNumber = '';
  }

  onOtherSelect(event: any) {
    this.isShopCommSelected = true;
    this.isRMSSelected = true;
    this.projectModel.generalInfo.projectDetails.rmsNumber = '';
    this.projectModel.generalInfo.projectDetails.shopCommItemNumber = '';
  }

  ngAfterViewInit() {
    // Query all nav-link elements inside mr-auto class and attach click event listener
    document.querySelectorAll('.mr-auto .nav-link').forEach(anchor => {
      anchor.addEventListener('click', (event) => this.onNavLinkClick(event));
    });
    // Listen to scroll events
    this.renderer.listen('window', 'scroll', () => {
      this.setActiveTabOnScroll();
    });

    //this.productsListComponent!.loadDefaultSelection(true);

    ////By Default, product selection should be manual
    this.productsListManualComponent?.loadDefaultSelection(true);
  }

  onFileChanged(e: any) {

    if (e.purpose == PurposeEnum.Stores) {
      if (e.selFile == null) {
        this.projectModel.generalInfo.storeList = e.selFile;
        //While Delete
        this.storesCount = -1;
      }
      else {
        this.projectModel.generalInfo.storeList = e.selFile;

      }
      if (this.storesCount == -1) {
        this.resetMaterialsStoresCount();
      }
    }
    else if (e.purpose == PurposeEnum.Products) {
      this.projectModel.products = e.selFile;
      if (e.selFile == null) {
        this.hasProductItems = false;
      }
      else {
        this.hasProductItems = true;
      }
    }
  }

  onStoreFileChanged(e: any) {
    this.storeFile = e.file;

    if (e.isValidatedStores) {
      this.validatedStoreNumbers = e.validatedStores;
      this.totalNumberOfStoresUploaded = e.totalCount;
      this.storesCount = e.totalCount;
    }
    else {
      if (e.file == null) {
        this.storesCount = e.totalCount;
      }
    }

    if (!this.projectModel.generalInfo.isStoreManual) {
      this.existingManualStoreNumbersList = null;
    }
    if (this.storesCount == -1) {
      this.resetMaterialsStoresCount();
    }
  }

  //Reset the Materials Store Count
  resetMaterialsStoresCount() {
    if (this.projectModel.projectMaterials != null && this.projectModel.projectMaterials.length > 0) {
      this.projectModel.projectMaterials.forEach(element => {
        element.numberOfStores = null;
        //element.qtyPerStore = null;
      });
    }
  }

  onKeyDatesChanged(e: GinfoKeyDatesVm) {
    this.projectModel.generalInfo.keyDates = e;
    this.projectModel.generalInfo.keyDates.startDateStr = e.startDateStr;
    this.setMinDate();
  }

  onExecutionProcess(projectId: number) {
    this.loadProjectDetails(projectId);
  }

  onProductFileChanged(e: any) {
    this.productFile = e.file;
  }

  onSelectedCategory(selectedValues: number[]) {
    //this.selectedCategories = selectedValues;
    this.unsavedChangesService.setUnsavedChanges(true);
    const unselected = this.previousSelectedCategories.filter(item => !selectedValues.includes(item));
    if (this.projectId > 0) {
      if (unselected.length > 0) {
        this.categorySelectionConfirmation(selectedValues, unselected);
      } else {
        this.previousSelectedCategories = [...selectedValues];
      }
    }
    //this.projectModel.generalInfo.projectDetails.selectedCategories = selectedValues.length > 0 ? selectedValues[0] : null;
    this.thirdPartyAgencies = [];
    this.GetThirdPartyAgencies();
    this.getProductsByCategories();
  }


  onCommuncation(event: any) {
    this.reciveCoomunication = event;
  }

  onProductSelectionUpdate(event: any) {
    //alert(event);
    if (event.from == "manual") {
      this.projectModel.generalInfo.projectDetails.isProductManual = true;
      //this.projectModel.products = null;
    }
    else if (event.from == "list") {
      this.projectModel.generalInfo.projectDetails.isProductManual = false;
      // this.projectModel.productsManual = null;
    }
  }

  onUpdatePRoductRows(event: ProductListManualVm[]) {
    this.projectModel.productsManual = event;
    this.projectModel.generalInfo.projectDetails.isProductManual = true;
    this.projectModel.products = null;
    const hasParent = event?.some(row => row.isParentSelected);
    const childRows = event?.filter(row => !row.isParentSelected);

    // Show the message if there is no parent and only one child
    if (!hasParent && childRows.length >= 1) {
      this.msgService.htmlError("Please add at least one parent to add a child");
    }

    const isValidForAnyProduct = this.hasValidValuesInProducts(event);
    if (isValidForAnyProduct) {
      this.hasProductItems = true;
    }
    else {
      this.hasProductItems = false;
    }
  }

  hasValidValuesInProducts(products: ProductListManualVm[]) {
    return products.some(product => {
      if (!product.isItRemove && product.isManuallyAddedNewProduct) {
        return product.newProductTitle || product.vendorItemNumber || product.upc;
      } else {
        return product.product || product.vendorItemNumber || product.upc;
      }
    });
  }

  onRButtonStatus(event: any): void {
    if (event.from == "productListManual") {
      this.projectModel.generalInfo.projectDetails.isProductManual = true;
      this.projectModel.products = null;
    }
    else if (event.from == "productList") {
      this.projectModel.generalInfo.projectDetails.isProductManual = false;
      this.projectModel.productsManual = null;
    }
    else {
      this.projectModel.generalInfo.projectDetails.isProductManual = false;
    }
  }

  inActiveStores: any[] = [];

  async validateStores(): Promise<boolean> {
    let inputModel: StoreValidationRequestVM = new StoreValidationRequestVM();

    if (this.projectModel!.generalInfo.storeList! != null) {
      inputModel.storeNubersList = this.projectModel!.generalInfo.storeList!.storeNumbers!;
    } else if (this.projectModel!.generalInfo.storeListManual! != null) {
      inputModel.storeNubersList = this.projectModel!.generalInfo.storeListManual!.storeNumbers!;

      let isManualStoreNoListChanged;

      if (this.existingManualStoreNumbersList! !== null && this.existingManualStoreNumbersList! !== undefined) {
        isManualStoreNoListChanged = this.compareManualStoreIdLists(this.existingManualStoreNumbersList!, inputModel.storeNubersList);
      }
      else {
        isManualStoreNoListChanged = true; //When changed from File Upload to Manual
      }

      if (isManualStoreNoListChanged) {
        this.projectModel!.generalInfo.storeListManual!.fileChanged = true;
      }
      else {
        this.projectModel!.generalInfo.storeListManual!.fileChanged = false;
      }
    }

    if (inputModel.storeNubersList != null && inputModel.storeNubersList.length > 0) {

      let allHawaiiStore = this.selectedStoresByStates.map(x => x.storeNumber).join(',');

      const hasStoreNumbersChanged = this.isAnyChangesOnStoreNumbers(this.existingStoreNumbers!, inputModel.storeNubersList!);

      if (hasStoreNumbersChanged) {
        const hasStoreNumbersPendingValidation = this.isAnyChangesOnStoreNumbers(this.validatedStoreNumbers!, inputModel.storeNubersList!);

        if (hasStoreNumbersPendingValidation) {
          this.msgService.htmlError(ProjectConstants.STORE_VALIDATION_PENDING);
          return false;
        }

        let storeToIdentify = this.getStoresToIdentify(allHawaiiStore, inputModel.storeNubersList, this.projectModel.identifiedStores!);

        if (storeToIdentify !== '' && this.projectModel.generalInfo.projectDetails.projectId > 0) {
          this.msgService.htmlError(ProjectConstants.STORE_NOTIFICATION_PENDING);
          return false;
        }
        else if (storeToIdentify !== '' && this.projectModel.generalInfo.projectDetails.projectId === 0) { // For New Project, ISO notification in API
          this.projectModel.storesToIdentify = storeToIdentify;
          return true;
        }
        else {
          this.storeListComponent!.errorDetails = "";
          return true; // Validation succeeded
        }
      } else {
        this.storeListComponent!.errorDetails = "";
        return true;
      }
    } else {
      // No stores to validate
      this.storeListComponent!.errorDetails = "";
      return true; // No validation needed, proceed with saving
    }

    // if (inputModel.storeNubersList != null && inputModel.storeNubersList.length > 0) {
    //   this.ngxService.start();

    //   try {
    //     const result = await this.projectService.validateStoreNumbers(inputModel).toPromise(); // Convert observable to promise
    //     this.inActiveStores = [...result.inActiveStores, ...result.inValidStores];
    //     //this.storesByStates = result.storesByStates;

    //     if (this.inActiveStores.length > 0) {
    //       this.msgService.htmlError("There are Invalid / Inactive stores please correct and try to save again.");
    //       const storeIdsString = this.inActiveStores.map(store => store.storeNumber).join(',');

    //       this.storeListComponent!.errorDetails = `There are Invalid / Inactive stores. Please correct and try again. Store# are: ${storeIdsString}`;
    //       return false; // Validation failed
    //     } else {
    //       this.storeListComponent!.errorDetails = "";
    //       return true; // Validation succeeded
    //     }

    //   } catch (error) {
    //     console.error('Error during store validation:', error);
    //     return false; // Error occurred, treat as failed validation
    //   } finally {
    //     this.ngxService.stop(); // Ensure loading is stopped
    //   }
    // } else {
    //   // No stores to validate
    //   this.storeListComponent!.errorDetails = "";
    //   return true; // No validation needed, proceed with saving
    // }
  }

  compareManualStoreIdLists(existingManualStoreList: string, currentManualStoreList: string): boolean {
    const existingManualStoreArray = existingManualStoreList.split(',').map(id => id.trim());
    const currentManualStoreArray = currentManualStoreList.split(',').map(id => id.trim());

    existingManualStoreArray.sort();
    currentManualStoreArray.sort();

    if (existingManualStoreArray.length !== currentManualStoreArray.length) {
      return true; // Mismatch
    }

    for (let i = 0; i < existingManualStoreArray.length; i++) {
      if (existingManualStoreArray[i] !== currentManualStoreArray[i]) {
        return true; // Mismatch
      }
    }

    return false; // No mismatch
  }

  async validateProjectData(isreadyForReview: boolean = false): Promise<boolean> {
    let validMsgs: any[] = [];
    let pwrNoValid: boolean = false;
    let pwrDateValid: boolean = false;

    if (this.selectedCategories.length > 0) {
      this.projectModel.selectedCategories = this.selectedCategories;
    }

    if (this.projectModel.selectedCategories && this.projectModel.selectedCategories.length == 0) {
      validMsgs.push(ProjectConstants.GENERALINFO_KEY_CATEGORY_REQUIRED);
    }

    this.childComponent?.validateFields()!.forEach(item => {
      validMsgs.push(item);
    });

    if (validMsgs.length! > 0) {
      const combinedMessages = validMsgs.join('<br/>');
      this.msgService.htmlError(combinedMessages);
      return false;
    }

    const isValidStores = await this.validateStores();
    if (!isValidStores) {
      return false;
    }

    let storesCount = 0;
    if (this.projectModel.generalInfo.storeList != null) {
      storesCount = this.projectModel.generalInfo.storeList?.rowsTotalCount!;
    }
    if (this.projectModel.generalInfo.storeListManual?.storeNumbers! != null && this.projectModel.generalInfo.storeListManual?.storeNumbers! != "") {
      storesCount = this.projectModel.generalInfo.storeListManual?.storeNumbers.split(',').length!;
    }

    let projectCostEstimateStoreCount = 0;
    if (this.projectModel.projectCost && this.projectModel.projectCost.length > 0) {
      projectCostEstimateStoreCount = this.projectModel.projectCost
        .map(pc => pc.numberOfStores || 0)
        .reduce((sum, val) => sum + val, 0);
    }

    if (projectCostEstimateStoreCount > storesCount) {
      this.msgService.htmlError(
        `Cost is calculated for ${projectCostEstimateStoreCount} stores, which is higher than the total available stores (${storesCount}).`
      );
      return false;
    }

    if (this.projectModel.generalInfo.projectDetails.isProductManual === true) {
      this.projectModel.products = null;
    } else {
      this.projectModel.productsManual = null;
    }

    this.projectModel.generalInfo.projectDetails.dueToShippingFacility = this.projectModel.generalInfo.projectDetails.dueToShippingFacility ? moment(this.projectModel.generalInfo.projectDetails.dueToShippingFacility).format('YYYY-MM-DD') : null;

    this.projectModel.generalInfo.projectDetails.isProductReviewConfirmed
      = this.productsListComponent?.isProductReviewChecked;

    if (this.projectModel.generalInfo.projectDetails.pwrNumber != null
      && this.projectModel.generalInfo.projectDetails.pwrNumber != undefined
      && this.projectModel.generalInfo.projectDetails.pwrNumber.length > 0
    ) {
      pwrNoValid = true;
    }

    if (this.projectModel.generalInfo.keyDates.pwrDateStr != null
      && this.projectModel.generalInfo.keyDates.pwrDateStr != undefined
      && this.projectModel.generalInfo.keyDates.pwrDateStr != 'Invalid date'
      && this.projectModel.generalInfo.keyDates.pwrDateStr.length > 0
    ) {
      pwrDateValid = true;
    }

    if (isreadyForReview) {
      this.fundingRmsComponent?.validateFields()!.forEach(item => {
        validMsgs.push(item);
      })
    }

    if (this.projectModel.projectStatus!.statusID == 2
      && this.projectModel.projectApproval?.isApproveClicked
      && !pwrNoValid!
    ) {
      validMsgs.push('PWR REQUEST# is required');
    }
    else if (this.projectModel.projectStatus!.statusID == 2
      && this.projectModel.projectApproval?.isApproveClicked
      && !pwrDateValid!
    ) {
      validMsgs.push('PWR DATE is required');
    }

    ///New product validations
    if (this.projectModel.productsManual &&
      this.projectModel.productsManual.some(product => product.isManuallyAddedNewProduct === true && product.productID == 0 && product.isItRemove == false) &&
      this.selectedNewProductCategoryId === undefined
    ) {
      validMsgs.push(NewlyAddedProductsConstants.Product_Category);
    }
    if (isreadyForReview && this.projectModel.productsManual) {
      const result = this.hasEmptyRequiredPropertiesForNewProduct(this.projectModel.productsManual);
      if (result) {
        validMsgs.push(NewlyAddedProductsConstants.Product_Fields);
      }
    }

    /// Check newly added custom product Itemnumber  validations
    if (isreadyForReview && this.projectModel.productsManual) {
      const result = await this.getAddProjectResult(this.projectModel.productsManual);
      if (result.length > 0) {
        result.forEach((item: any) => {
          validMsgs.push(`Product ' ${item.productDesc} ' Item Number ${item.itemNumber} already exists`);
        });
      }
    }

    /// Validation criteria validation
    const filterCriteria = this.projectModel?.projectValidationCriterias?.filter(criteria => criteria.projectID !== undefined && criteria.projectID > 0);
    if (filterCriteria && filterCriteria.length > 0) {
      // Trim criteriaText before checking
      filterCriteria.forEach(criteria => {
        if (criteria.criteriaText) {
          criteria.criteriaText = criteria.criteriaText.trim();
        }
      });

      // Check if there's criteria text but no response type
      const invalidCriteria = filterCriteria.some(criteria =>
        criteria.criteriaText && !criteria.responseType
      );
      // Check if there's response type but no criteria text
      const invalidResponseType = filterCriteria.some(criteria =>
        criteria.responseType && !criteria.criteriaText
      );
      // Check for duplicate criteriaText when responseType is 'dropdown'
      const dropdownCriteriaTexts = filterCriteria
        .filter(criteria => criteria.responseType === 'Dropdown' && criteria.criteriaText)
        .map(criteria => criteria.criteriaText);

      const duplicateCriteria = dropdownCriteriaTexts.some(
        (criteria, index, arr) => arr.indexOf(criteria) !== index
      );

      if (isreadyForReview && invalidCriteria) {
        validMsgs.push(ValidationCriteriaConstants.Response_Type);
      }
      if (isreadyForReview && invalidResponseType) {
        validMsgs.push(ValidationCriteriaConstants.Criteria_Text);
      }
      if (isreadyForReview && duplicateCriteria) {
        validMsgs.push(ValidationCriteriaConstants.Duplicate_Criteria);
      }
    }

    if (validMsgs.length! > 0) {
      const combinedMessages = validMsgs.join('<br/>');
      this.msgService.htmlError(combinedMessages);
      return false;
    }
    else {
      return true;
    }

  }

  async saveProject() {

    let isValidProjectData = await this.validateProjectData();

    this.unsavedChangesService.setUnsavedChanges(false);

    if (isValidProjectData) {
      this.assignCategoryToProducts(this.projectModel);

      if (this.projectModel.projectStatus!.statusID == 2
        && this.projectModel.projectApproval?.isApproveClicked
      ) {
        let uInfo: UserLogin | null = this.storageService.getItem<UserLogin>("UserInfo");
        this.projectModel.projectStatus!.changedBy = uInfo?.userID;
        this.projectModel.projectStatus!.changedDate = new Date();
        this.projectModel.projectStatus!.isApproved = false;
        this.projectModel.projectStatus!.refID = this.projectModel.generalInfo.projectDetails.projectId;
        this.projectModel.projectStatus!.statusID = 3;
        this.projectModel.projectStatus!.type = RefTypeEnum.Project;
      }

      if (this.activities.length > 0) {
        this.projectModel.projectActivities = this.activities;
      }
      /// Providing confirmation for the category selection is not changeable once the project is created 
      /// and we are showing it only for the first time project create.
      if (this.projectId > 0) {
        this.finalSaveProject();
      }
      else {
        // this.categorySelectionConfirmation();
        this.finalSaveProject();
      }
    }
  }

  deleteProject() {
    this.projectService.deleteProjects(this.projectModel.generalInfo.projectDetails.headerId, "Project").subscribe({
      next: async (data: any) => {
        if (data) {
          this.router.navigate(['/manage-projects']);
        }
      }
    })

  }
  cancelProject() {
    if (this.projectId > 0) {
      this.confirmService.confirm({
        header: ' ',
        icon: 'pi pi-exclamation-triangle',
        message: "This action cannot be reversed. Are you sure to delete the Project?",
        accept: () => {

          //this.finalSaveProject();
          this.deleteProject();


        },
        reject: () => {
          return;
        }
      })
    }


  }

  categorySelectionConfirmation(selected: any, unselected: any) {
    this.confirmService.confirm({
      header: ' ',
      icon: 'pi pi-exclamation-triangle',
      message: "Removing the category will also delete any associated products. Do you want to proceed?",
      accept: () => {

        //this.finalSaveProject();
        this.selectedCategories = [...selected];
        this.deleteProductByCategory(unselected);


      },
      reject: () => {
        this.selectedCategories = [...this.previousSelectedCategories];
        return;
      }
    })
  }
  deleteProductByCategory(categoryId: number) {
    this.projectService.deleteProductByCategory(this.projectId, "Project", categoryId).subscribe({
      next: async (data: any) => {
        if (data) {
          this.projectModel.productsManual = this.projectModel.productsManual!.filter(x => x.categoryID != categoryId);
          this.projectModel.selectedCategories = this.selectedCategories;
          // this.loadProjectDetails(this.projectId);
          this.finalSaveProject();
        }
      }
    })
  }

  ///this is called to save the project after all required validations passed
  finalSaveProject() {
    this.ngxService.start();
    //console.log('finalSaveProject', this.projectModel);
    this.projectService.addEditProjectDetails(this.projectModel).subscribe({
      next: async (data: any) => {
        if (data.result > 0) {
          if (data.status == 1) {
            let inActiveStores = [...data.message.inActiveStores, ...data.message.inValidStores];
            // Extract the storeId from each store and join them with a comma
            const storeIdsString = inActiveStores.map((store: { storeNumber: any; }) => store.storeNumber).join(',');
            const msg = `The following store IDs (${storeIdsString}) are inactive or invalid and have been excluded from the list during the saving process.`;

            this.msgService.htmlError("There are Invalid / Inactive stores please correct and try to save agian.");

            this.storeListComponent!.errorDetails = `There are Invalid / Inactive stores please correct and try to save agian. Store# are: ${storeIdsString}`;
            this.ngxService.stop();
          }
          else {
            this.msgService.htmlSuccess("Project Saved Successfully");


            this.selectedNewProductCategoryId = undefined;
            this.ngxService.stop();

            // if you are alaready roted to edit page and agian
            // try to route smae page not happeing so in that case loading the data.
            if (this.projectModel.projectStatus!.statusID! > 1) {
              this.loadProjectDetails(data.result);
            }
            else {
              const encodedParam = encodeURIComponent(data.result);
              //this.router.navigate(['/projectintake/editproject', headerid]);
              this.router.navigate(['/projectintake/editproject', this.encodeDecodeService.encode(data.result)]);
            }
            if (this.projectModel.projectAttachments.length > 0) {
              this.loadProjectDetails(data.result);
            }
          }
        }
        else {
          let validMsgs: string[] = [];

          if (data.installationProductResultDto.length > 0) {
            data.installationProductResultDto.forEach((item: any) => {
              validMsgs.push(`Product Description ${item.productDesc} Item Number ${item.itemNumber} already exists`);
            });
            const combinedMessages = validMsgs.join('<br/>');
            this.msgService.htmlError(combinedMessages);
          }
          else {
            this.msgService.htmlWarning('Not able to save project details');
            this.errorLogService.logMessage(
              {
                message: 'something went wrong, validate your input',
                object: this.projectModel
              }, 'saveProject');
          }
          this.ngxService.stop();
        }
      },
      error: (error) => {
        //this.msgService.htmlError('Error occured while saving the project.');
        this.errorLogService.logError(error, 'saveProject');
        this.ngxService.stop();
      },
    });
  }

  enableDisableControl(approvalStage: any) {
    if (approvalStage == ProjectApprovalStage.REQUESTAPPROVAL && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) {
      this.disableAll = false;
    } else if (approvalStage == ProjectApprovalStage.ACTIONREQUIRED && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) {
      if (!this.disableAll) {
        this.disableAll = false;
      }
    } else if (approvalStage == ProjectApprovalStage.APPROVED) {
      this.disableAll = true;
    }
    else if (approvalStage == ProjectApprovalStage.LOCKED) {
      this.disableAll = true;
    }
    else if (approvalStage == ProjectApprovalStage.UNLOCKED && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) {
      this.disableAll = true;
    }
    else if (approvalStage == ProjectApprovalStage.UNLOCKED && this.userRoleService.role?.roleKey == RoleKey.SREAdmin) {
      this.disableAll = false;
    }
    else if (approvalStage == ProjectApprovalStage.UNLOCKED && this.userRoleService.role?.roleKey == RoleKey.SRESupport) {
      this.disableAll = false;
      if (this.userRoleService.role?.write == false) {
        this.disableAll = true;
      }

    }
    if (this.disableAll && this.userRoleService.role?.roleKey !== RoleKey.SREAdmin) { //disable save for SRE support read role
      if (this.userRoleService.role?.roleKey == RoleKey.SRESupport) {
        if (this.userRoleService.role?.write !== true) {
          const divElement = this.saveDiv.nativeElement;
          if (divElement) {
            divElement.style.pointerEvents = 'none'; // Disable mouse interactions
            divElement.style.opacity = '0.5'; // Optional: make the div look disabled
          }

        }
      }
    }
    if (this.disableAll && this.userRoleService.role?.roleKey == RoleKey.CustomerTeam) { //disable save for customer team
      const divElement = this.saveDiv.nativeElement;
      if (divElement) {
        divElement.style.pointerEvents = 'none'; // Disable mouse interactions
        divElement.style.opacity = '0.5'; // Optional: make the div look disabled
      }
    }

  }

  async loadProjectDetails(headerid: number) {
    this.ngxService.start();
    this.isValidationCriteria = false;
    await this.projectService.getProjectDetails(headerid).subscribe({
      next: async data => {
        this.projectModel = data;
        ///to load the project cost component
        this.isProjectModeDecided = true;
        this.isValidationCriteria = true;
        if (this.projectModel.projectApproval) {
          let approvalStage = this.projectModel.projectApproval.approvalStage;
          this.enableDisableControl(approvalStage);

        }
        this.selectedCategories = this.projectModel.selectedCategories;
        this.previousSelectedCategories = [...this.selectedCategories];

        if (this.selectedCategories.length > 0) {
          await this.GetThirdPartyAgencies();
          this.getProductsByCategories();
        }

        if (this.projectModel.generalInfo.storeList?.rowsTotalCount! > 0) {
          this.totalNumberOfStoresUploaded = this.projectModel.generalInfo.storeList?.rowsTotalCount;
          this.existingStoreNumbers = this.projectModel.generalInfo.storeList?.storeNumbers;
          this.validatedStoreNumbers = this.projectModel.generalInfo.storeList?.storeNumbers;
          this.storesCount = this.totalNumberOfStoresUploaded!;
        }
        if (this.projectModel.generalInfo.storeListManual?.storeNumbers! != null) {
          this.existingManualStoreNumbersList = this.projectModel.generalInfo.storeListManual?.storeNumbers;
          this.existingStoreNumbers = this.existingManualStoreNumbersList;
          this.validatedStoreNumbers = this.existingManualStoreNumbersList;
        }
        this.selectedIdentifiedStoreNumbers = this.projectModel.identifiedStores!;
        if (data && data.projectStatus && data.projectStatus.statusID) {
          //if (data.projectStatus.statusID == 5 || data.projectStatus.statusID == 6) {
          if (data.projectStatus.statusID == 6) {
            const divElement = this.saveDiv.nativeElement;
            if (divElement) {
              divElement.style.pointerEvents = 'none'; // Disable mouse interactions
              divElement.style.opacity = '0.5'; // Optional: make the div look disabled
            }
          }
        }

        let productSelection = false;
        let productSelectionManual = false;
        if (this.projectModel.products != null) {
          productSelection = true;
          productSelectionManual = false;
          //this.productsListComponent?.loadDefaultSelection(true);
        }

        if (this.projectModel.productsManual != null
          && this.projectModel.productsManual.length > 0
        ) {
          productSelection = false;
          productSelectionManual = true;
          //this.productsListComponent?.loadDefaultSelection(true);
        }

        if (productSelection) {
          this.productsListComponent?.loadDefaultSelection(true);
        }
        else {
          //By Default, product selection should be manual   
          this.productsListManualComponent?.loadDefaultSelection(true);
        }

        if ((this.projectModel.products != null) || (this.projectModel.productsManual != null
          && this.projectModel.productsManual.length > 0)) {
          this.hasProductItems = true;
        }
        else {
          this.hasProductItems = false;
        }

        if (this.hasProductItems && this.projectModel.productsReviewLog != null && this.projectModel.productsReviewLog.length > 0) {
          this.productReviewedBy = this.projectModel.productsReviewLog[0].reviewedBy!;
          this.productReviewedDate = this.projectModel.productsReviewLog[0].reviewedOn;
        }

        if (this.projectModel.generalInfo.projectDetails.dueToShippingFacility) {
          this.projectModel.generalInfo.projectDetails.dueToShippingFacility
            = new Date(this.projectModel.generalInfo.projectDetails.dueToShippingFacility!);
        }

        if (this.projectModel.generalInfo.materialRMS && this.projectModel.generalInfo.materialRMS?.length > 0
          && this.projectModel.generalInfo.projectDetails.shippingFrom == "RMS") {
          this.isRMSSelected = false;
        }
        if (this.projectModel.generalInfo.projectDetails.shopCommItemNumber
          && this.projectModel.generalInfo.projectDetails.shippingFrom == "ShopCOMM") {
          this.isShopCommSelected = false;
        }

        this.projectModel.generalInfo.projectDetails.ctRequester = this.uInfo?.userID;
        this.userDisplayName = this.projectModel.generalInfo.projectDetails.ctRequesterName!;

        if (this.storeListComponent! != null
          && this.storeListComponent! != undefined
        ) {
          this.storeListComponent!.downloadLink
            = `Stores_${this.projectModel.generalInfo.projectDetails.projectTitle}.xlsx`;
        }

        if (this.productsListComponent! != null
          && this.productsListComponent! != undefined
        ) {
          this.productsListComponent!.downloadLink
            = `Products_${this.projectModel.generalInfo.projectDetails.projectTitle}.xlsx`;
        }

        if (this.productsListManualComponent! != null
          && this.productsListManualComponent! != undefined
        ) {
          this.productsListManualComponent!.downloadLink
            = `${this.projectModel.generalInfo.projectDetails.projectTitle}_Products.xlsx`;
        }

        this.projectTitleDisplay = this.projectModel.generalInfo.projectDetails.projectTitle;

        this.enablePWR
          = ((this.projectModel.projectStatus!.statusID! > 1
            && (this.projectModel.projectApproval?.approvalStage == ApprovalConstants.Approval_Approved
              || this.projectModel.projectApproval?.approvalStage == ApprovalConstants.Approval_LOCKED
              || this.projectModel.projectApproval?.approvalStage == ApprovalConstants.Approval_UNLOCKED
            ))
            || (this.projectModel.projectStatus!.statusID! > 2)) ?
            (this.uInfo!.roles[0].roleID == 2 || (this.uInfo!.roles[0].roleID == 3 && this.uInfo!.roles[0].write == true) ? true : false) :
            false;

        this.loadDefaultDataMapping();

        // let statusBUbble = this.commonApprovalComponent?.setWizardStatus(
        //   this.projectModel.projectStatus!, this.projectModel.projectApproval!
        // );
        // this.bubbleStatusUpdate(statusBUbble);


        this.displayBubbleStatus = this.commonApprovalComponent?.setWizardStatusNew(
          this.projectModel.projectStatuses!, this.projectModel.projectStatusMaster!,
          this.projectModel.projectApproval!
        );

        if ((this.projectModel.projectStatus!.statusID! == 2
          && this.projectModel.projectApproval?.isReviewClicked
          && this.projectModel.projectApproval?.isApproveClicked == false)
        ) {
          if (await this.userRoleService.canEdit()) {
            this.disableAfterReview = false;
          }
          else {
            this.disableAfterReview = true;;
          }
        }
        else {
          if ((this.projectModel.projectStatus!.statusID! >= 2
            && this.projectModel.projectApproval?.isReviewClicked == false
            && this.projectModel.projectApproval?.isApproveClicked == true)
          ) {
            if (await this.userRoleService.canscreenEditAfterApprove()) {
              this.disableAfterReview = false;
            }
            else {
              this.disableAfterReview = true;;
            }
          }
          else {
            this.disableAfterReview = false;
          }
        }

        // if(this.projectModel.generalInfo.projectDetails.isProductManual)
        // {
        //   this.productsListManualComponent!.isProductListManualChecked = true;
        //   this.productsListComponent!.isProductListChecked = false;
        // }
        // else
        // {
        //   this.productsListManualComponent!.isProductListManualChecked = false;
        //   this.productsListComponent!.isProductListChecked = true;
        // }
        if (this.projectModel.projectAttachments.length == 0) {
          this.addAttachmentsItem();
        }
        if (this.projectModel.projectMaterials.length == 0) {
          this.addMaterialItem();
        }

        if (this.projectModel.projectActivities.length > 0) {
          this.projectModel.projectActivities.forEach(x => {
            this.activities[this.activities.findIndex(y => y.activityID == x.activityID)].isChecked = x.isChecked;
          })
        }
        if (this.projectModel.generalInfo.projectDetails.projectId <= 0) {
          this.msgService.htmlWarning("Data not found.");
        }
        //this.toastr.info("Loading completed.");

        if (this.projectModel.generalInfo.materialRMS && this.projectModel.generalInfo.materialRMS.length === 0) {
          this.projectModel.generalInfo.materialRMS = [];
          this.addRMSItem();
        }
        this.filterRMSItems();

        this.ngxService.stop();
        this.showCommonProductsListManualComponent = true;

        if (this.projectModel.projectCost == null) {
          this.projectModel.projectCost = [];
        }
      },
      error: error => {
        //this.msgService.htmlError('Error occured');
        this.errorLogService.logError(error, 'loadProjectDetails');
        this.ngxService.stop();
      }
    });

  }

  private loadDefaultDataMapping() {
    //let uInfo: UserLogin | null = this.storageService.getItem<UserLogin>("UserInfo");
    this.projectModel.generalInfo.projectDetails.orgId = this.uInfo?.orgID!;

    this.projectModel.generalInfo.projectDetails.vendorId
      = this.storageService.getItem<any>("selectedVendor").vendorID;

    this.projectModel.generalInfo.projectDetails.type = RefTypeEnum.Project;
    this.projectModel.generalInfo.projectDetails.changedBy = this.uInfo?.userID!;
    this.projectModel.generalInfo.projectDetails.ctRequester = this.uInfo?.userID;

    if (this.projectModel.generalInfo.projectDetails.projectId > 0) {
      this.initiatedClass = this.initiatedClass + " active";
    }

  }

  disableApprovalSection() {
    if (this.projectModel.generalInfo.projectDetails.projectId > 0) {
      this.enableApproval = true;
    }
    else {
      this.enableApproval = false
    }
  }

  onNavLinkClick(event: Event) {
    event.preventDefault();

    // Remove "active" class from all nav-link elements within mr-auto
    document.querySelectorAll('.mr-auto .nav-link').forEach(link => {
      link.classList.remove('active');
    });

    // Add "active" class to the clicked element
    (event.currentTarget as HTMLElement).classList.add('active');

    const targetId = (event.currentTarget as HTMLAnchorElement).getAttribute('href')?.substring(1);
    const targetElement = document.getElementById(targetId || '');

    if (targetElement) {
      const fixedSection = document.querySelector<HTMLElement>('.fixed-section');
      const topOffset = fixedSection ? fixedSection.offsetHeight : 0;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: targetPosition - topOffset,
        behavior: 'smooth'
      });
    }
  }

  objectivesChanged(currentObjectives: any) {
    this.projectModel.projectObjectives = currentObjectives;
  }

  addMaterialItem(index = 0) {
    this.projectModel.projectMaterials?.splice(index, 0, new ProjectMaterial());

  }

  removeMaterialItem(index: number) {
    this.projectModel.projectMaterials?.splice(index, 1);
  }

  addAttachmentsItem(index = 0) {
    this.projectModel.projectAttachments?.splice(index, 0, new ProjectAttachement());
  }

  downloadShopCOMMWordDocument(event: Event): void {
    this.ngxService.start();
    if (this.agencyId! > 0) {
      this.projectService.downloadShopCommWordDocument(this.agencyId).subscribe((shopCommWordDocumentData: any) => {

        this.ShopComDataUrl = `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${shopCommWordDocumentData.base64Data}`;

        const downloadLink = document.createElement('a');
        downloadLink.href = this.ShopComDataUrl;
        downloadLink.download = `ShopCOMM_${this.agencyName}.docx`;
        downloadLink.click();
        this.ngxService.stop();

      }, (err) => {
        if (err.status === 404) {
          this.isShopComButtonVisible = false;
        }
        this.msgService.htmlError("File Not Found for selected Agency");
        this.ngxService.stop();
      });
    }
    else {
      this.msgService.htmlError("Select Agency to Download the ShopComm Document");
      this.ngxService.stop();
    }
  }

  removeAttachmentsItem(index: number) {
    // Remove item at specified index
    this.projectModel.projectAttachments?.splice(index, 1);
    this.onDeleteAttachmentFile(index);
  }

  getUnequeValue(name: string, i: any) {
    return name + '-' + i.toString();
  }

  onProjectCostEstimates(event: { items: ProjectCost[], totalEstimationCost: number }): void {
    this.projectModel.projectCost = event.items;
    if (!this.isPageLoad) {
      setTimeout(() => {
        this.newEstimationCost = event.totalEstimationCost!;
      });
    }
    this.agencyId = this.projectModel.projectCost[0].categoryAgencyID;
    if (this.agencyId && this.thirdPartyAgencies) {
      this.setAgencyDocDetails();
    }
    this.isPageLoad = false;
  }
  setAgencyDocDetails() {
    this.agency = this.thirdPartyAgencies.find((x: any) => x.categoryAgencyID == this.agencyId);
    if (this.agency) {
      this.agencyName = this.agency.agencyName;

      if (this.agencyName !== 'Anderson') {
        this.projectModel.generalInfo.projectDetails.shippingFrom = '';
        this.projectModel.generalInfo.projectDetails.shopCommItemNumber = '';
      }
      this.projectService.downloadShopCommWordDocument(this.agencyId).subscribe((shopCommWordDocumentData: any) => {
        if (shopCommWordDocumentData != null) {
          this.isShopComButtonVisible = true;
        }
      }, (err) => {
        if (err.status === 404) {
          this.isShopComButtonVisible = false;
        }
      });
    }
  }

  initiatedStatusClass: string = WizardStatus.ONPROGRESS;
  approvedStatusClass: string = "";
  pwrLinkedStatusClass: string = "";
  completedStatusClass: string = "";

  async onBubbleStatusChanged(bubleStatus: any) {
    this.loadProjectDetails(this.projectModel.generalInfo.projectDetails.projectId);
    //window.location.reload();
  }

  bubbleStatusUpdate(bubleStatus: any) {
    this.initiatedStatusClass = bubleStatus.initiated;
    this.approvedStatusClass = bubleStatus.approved;
    this.pwrLinkedStatusClass = bubleStatus.pwrlinked;
  }

  // setWizardStatus1(){
  //   if(this.projectModel.projectStatus?.statusID == 1)
  //   {
  //     this.initiatedStatusClass = WizardStatus.ACTIVE;
  //   }
  //   else if(this.projectModel.projectStatus?.statusID == 2)
  //   {
  //     if(this.projectModel.projectApproval!.isApproveClicked)
  //     {
  //       this.approvedStatusClass = WizardStatus.ACTIVE;
  //     }
  //     else if(this.projectModel.projectApproval!.isReviewClicked)
  //     {
  //       this.approvedStatusClass = WizardStatus.ONACTION;
  //     }
  //   }
  // }

  checkProjectMaterialLength() {
    return this.projectModel.projectMaterials?.length ?? 0;
  }

  checkProjectAttachmentLength() {
    return this.projectModel.projectAttachments?.length ?? 0;
  }

  async onShippingDateChange(ev: any) {
    this.unsavedChangesService.setUnsavedChanges(true);
    this.projectModel.generalInfo.projectDetails.dueToShippingFacility = ev;
  }

  setMinDate() {
    if (this.projectModel?.generalInfo?.keyDates?.startDateStr) {
      this.minDate = this.parseDate(this.projectModel.generalInfo.keyDates.startDateStr);
    }
  }

  parseDate(dateStr: string): Date {
    // Convert "19-Sep-2024" to "19 Sep 2024" format
    const [day, monthStr, year] = dateStr.split('-');
    const month = new Date(Date.parse(`${monthStr} 1, 2020`)).getMonth(); // Get month index from month name
    return new Date(+year, month, +day);
  }


  GetThirdPartyAgencies() {
    if (this.selectedCategories.length > 0) {
      const categoryIds = this.selectedCategories;
      this.projectService.getCategoryAgenciesByCategoryies(this.selectedCategories).subscribe(data => {
        if (data) {
          this.thirdPartyAgencies = data;
          if (this.agencyId && this.thirdPartyAgencies) {
            this.setAgencyDocDetails();
          }
        }
      })
    } else if (this.projectModel.selectedCategories.length > 0) {
      this.projectService.getCategoryAgenciesByCategory(this.projectModel.selectedCategories).subscribe(data => {
        this.thirdPartyAgencies = data;
        if (this.agencyId && this.thirdPartyAgencies) {
          this.setAgencyDocDetails();
        }
      });
    }
  }
  getProductsByCategories() {
    this.masterService.getProductsByCategories(this.selectedCategories).subscribe(res => {
      if (res) {
        this.productItems = [];
        this.productItems = res;
      }
    });
  }

  onChangeFundingRMS(event: FundingAndRMS) {
    this.projectModel.fundingAndRMSVM = event;
  }

  onChangeInstructions(event: InstructionsVM) {
    this.projectModel.instructionsVM = event;
    this.errorLogService.logMessage(this.projectModel.instructionsVM, "Project > onChangeInstructions");
  }

  onChangeTemplateData(event: ProjectTemplateInstructionsVm[]) {
    this.projectModel.projectTemplateInstructions = event;
  }

  onReadyForReviewClicked(event: any) {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.setActiveTabOnScroll();
  }

  ///this code is for tp heilight the tab when scroll the page
  private setActiveTabOnScroll(): void {
    const sections = document.querySelectorAll('div[id]');
    const scrollPosition = window.scrollY + window.innerHeight / 2;
    const buffer = 10;

    let newActiveTab = 'generalInfo';

    sections.forEach((section) => {
      const element = section as HTMLElement;
      const sectionTop = element.getBoundingClientRect().top + window.scrollY - buffer;
      const sectionHeight = element.offsetHeight;
      const sectionId = section.getAttribute('id') || '';

      if ((scrollPosition >= sectionTop) && (scrollPosition < (sectionTop + sectionHeight + buffer))) {
        newActiveTab = sectionId;
      }
    });
    if (newActiveTab !== this.activeTab) {
      this.activeTab = newActiveTab;
    }
  }

  materialDescription(test: any, i: any) {
    this.projectModel.projectMaterials[i].materialDescription = this.mstMaterials[this.mstMaterials.findIndex(x => x.materialID == test.materialID)].materialName;
  }

  async onFileSelected(e: any) {
    let projFIleID = 0;
    let refId = 0;

    const files = Array.from(e.target.files);

    this.projectAttachmentFiles = [];

    if (this.projectAttachmentFile == null) {
      this.projectAttachmentFile = new ProjectAttachmentFilesVm();
    }

    if (this.projectAttachmentFile != null && this.projectAttachmentFile != undefined) {
      projFIleID = this.projectAttachmentFile!.projectFileID!;
      refId = this.projectAttachmentFile!.refID! | 0;
    }

    if (this.projectModel.projectAttachments[0].description == "" && files.length > 0 && (files[0] as File).size <= 5 * 1024 * 1024) {
      this.projectModel.projectAttachments?.splice(0, 1);
    }

    files.forEach(async (file: any) => {

      if (file.size <= 5 * 1024 * 1024) {

        this.projectAttachmentFiles.push({
          projectFileID: projFIleID,
          fileName: file.name,
          purpose: this.purposeAttachments,
          type: this.refType,
          refID: refId,
          createdBy: this.storageService.getItem<any>('UserInfo').userID,
          filePath: file.name,
          createdDate: new Date(),
          fileIndex: -1,
          fileChanged: false,
          base64Bytes: await this.readFileAsBase64(file),
          rowsTotalCount: 0
        });

        // Push the new attachment object
        this.projectModel.projectAttachments.push({
          description: `${file.name} -  `,
          attachmentID: 0,
          pageCount: 0,
          printORView: '',
          projectID: this.projectId == null ? 0 : this.projectId,
          storeORRep: ''
        });

        const isFileExists = (file: any, existingFiles: any[]) =>
          existingFiles.some(existingFile => existingFile.fileName === file.fileName);

        this.projectModel.projetAttachmentFiles = [
          ...this.projectModel.projetAttachmentFiles,
          ...this.projectAttachmentFiles.filter(file => !isFileExists(file, this.projectModel.projetAttachmentFiles))
        ];
      } else {
        this.msgService.htmlError(`File ${file.name} is too large. Maximum size allowed is 5MB.`);
      }
    })
    this.unsavedChangesService.setUnsavedChanges(true);
    this.clearFileInput();
  }

  clearFileInput() {
    if (this.fileInputs && this.fileInputs.nativeElement) {
      this.fileInputs.nativeElement.value = '';
    }
  }

  onDeleteAttachmentFiles(index: any) {
    this.projectAttachmentFiles.splice(index, 1);
    this.projectModel.projetAttachmentFiles.splice(index, 1);
    this.projectModel.projectAttachments.splice(index, 1);
    if (this.projectModel.projectAttachments.length == 0) {
      this.addAttachmentsItem();
    }
  }

  onDeleteAttachmentFile(index: any) {
    this.projectAttachmentFiles.splice(index, 1);
    this.projectModel.projetAttachmentFiles.splice(index, 1);
    if (this.projectModel.projectAttachments.length == 0) {
      this.addAttachmentsItem();
    }
  }

  async downLoadFilePreview(event: Event, index: any) {
    this.ngxService.start();
    event.preventDefault();
    event.stopPropagation();

    let blob = this.base64ToBlob(this.projectModel.projetAttachmentFiles[index].base64Bytes!, this.contentType);

    this.downloadAllTypeFiles(blob, this.projectModel.projetAttachmentFiles[index].fileName!);
    this.ngxService.stop();
  }

  //exportAttachmentExcelZip() {

  //  const filteredAttachments = this.projectModel.projectAttachments.filter(attachment => attachment.attachmentID > 0);

  //  if (filteredAttachments.length === 0) {
  //    this.msgService.htmlError("No valid attachments to export");
  //    return;
  //  }

  //  // Prepare the data for the Excel file
  //  const data = filteredAttachments.map(attachment => ({
  //    'DESCRIPTION': attachment.description,
  //    'STORE OR REP': attachment.storeORRep,
  //    'PRINT OR VIEW': attachment.printORView,
  //    'PAGE COUNT': attachment.pageCount,
  //  }));

  //  // Create a new workbook and worksheet
  //  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  //  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //  XLSX.utils.book_append_sheet(wb, ws, 'Attachments');

  //  // Convert workbook to binary string
  //  const wbout: ArrayBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

  //  // Create a new ZIP file
  //  const zip = new JSZip();
  //  zip.file('ProjectAttachments.xlsx', wbout);

  //  // Generate the ZIP file and trigger a download
  //  zip.generateAsync({ type: 'blob' }).then((content: Blob) => {
  //    saveAs(content, `${this.projectTitleDisplay}_ProjectAttachments.zip`);
  //  });
  //}

  downloadAttachmentFilesAsZip() {
    const zip = new JSZip();
    const savedAttachmentFiles = this.projectModel.projetAttachmentFiles.filter(x => x.projectFileID! > 0);

    if (savedAttachmentFiles.length === 0) {
      this.msgService.htmlError("No valid attachment files to export");
      return;
    }

    savedAttachmentFiles.forEach(file => {
      if (file.base64Bytes) {
        // Decode base64 to binary
        const byteCharacters = atob(file.base64Bytes);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        zip.file(file.fileName || 'untitled', byteArray);
      }
    });

    // Generate the zip file and trigger download
    zip.generateAsync({ type: 'blob' }).then(content => {
      saveAs(content, `${this.projectTitleDisplay}_ProjectAttachments.zip`);
    });
  }



  exportMaterialExcel() {

    const filteredMaterials = this.projectModel.projectMaterials.filter(material => material.projectMaterialID > 0);

    if (filteredMaterials.length === 0) {
      this.msgService.htmlError("No valid materials to export");
      return;
    }

    const getMaterialType = (id: number): string => {
      const type = this.distinctMaterials.find(m => m.materialID === id);
      return type ? type.materialType : 'Unknown';
    };

    const data = filteredMaterials.map(material => ({
      'MATERIAL TYPE': getMaterialType(material.materialID),
      'MATERIAL DESCRIPTION': material.materialDescription,
      '# STORES': material.numberOfStores,
      'QTY. PER STORE': material.qtyPerStore,
      'ARTICLE #': material.article,
      'TOTAL QTY.': (material.numberOfStores ?? 0) * (material.qtyPerStore ?? 0)
    }));

    // Create a new workbook and worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Materials');

    const fileName = `${this.projectTitleDisplay} + ProjectMaterials`;
    // Generate the Excel file and trigger a download
    XLSX.writeFile(wb, `${this.projectTitleDisplay}_ProjectMaterials.xlsx`);
  }

  // validateRMSNumber(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   const value = input.value;

  //   const cleanedValue = value.replace(/[^0-9]/g, '');

  //   input.value = cleanedValue;

  //   this.projectModel.generalInfo.projectDetails.rmsNumber = cleanedValue ? parseInt(cleanedValue, 10) : null;
  // }

  // validateShopComNumber(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   const value = input.value;

  //   const cleanedValue = value.replace(/[^0-9]/g, '');

  //   input.value = cleanedValue;

  //   this.projectModel.generalInfo.projectDetails.shopCommItemNumber = cleanedValue ? parseInt(cleanedValue, 10) : null;
  // }

  validateRMSNumber(event: Event, rms: GinfoObjectiveProjectRMSVm): void {
    rms.status = MaterialRMSConstants.MaterialRMS_Update;
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Allow only alphanumeric characters (letters and numbers)
    const cleanedValue = value.replace(/[^A-Za-z0-9]/g, '');

    // Update the model and input field with the cleaned value
    rms.rmsNumber = cleanedValue;
    input.value = cleanedValue;
  }



  validateShopComNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    const cleanedValue = value.replace(/[^A-Za-z0-9]/g, '');

    this.projectModel.generalInfo.projectDetails.shopCommItemNumber = cleanedValue;
    input.value = cleanedValue;
  }

  onKeyPress(event: KeyboardEvent): void {
    const charCode = event.charCode || event.keyCode;
    const charStr = String.fromCharCode(charCode);

    // Allow only numeric characters
    if (!/^[0-9]$/.test(charStr)) {
      event.preventDefault();
    }
  }

  onNumberOfStores(event: Event, index: number): void {
    const target = event.target as HTMLInputElement;
    const inputValue = target.value;

    const cleanValue = inputValue.replace(/\D/g, '');
    const newValue = +cleanValue;

    if (newValue > this.totalNumberOfStoresUploaded!) {

      target.value = cleanValue.substring(0, cleanValue.length - 1);

      if (target.value == '') {
        this.projectModel.projectMaterials[index].numberOfStores = null;
      }
      else {
        this.projectModel.projectMaterials[index].numberOfStores = parseInt(target.value);
      }
    }
    else {
      // Update the value if it's valid
      if (newValue <= this.totalNumberOfStoresUploaded!) {
        this.projectModel.projectMaterials[index].numberOfStores = newValue;
      }
    }
  }

  // Method to add a new RMS item
  addRMSItem(): void {
    const newItem = new GinfoObjectiveProjectRMSVm();
    newItem.projectID = this.projectId;
    newItem.rmsNumber = '';
    newItem.status = MaterialRMSConstants.MaterialRMS_Add;
    this.projectModel.generalInfo.materialRMS.push(newItem);
    this.filterRMSItems();
  }

  // Method to remove an RMS item
  removeRMSItem(rmsData: GinfoObjectiveProjectRMSVm): void {
    const item = this.findOrRemoveRMSItem(rmsData);
    if (item) {
      item.status = MaterialRMSConstants.MaterialRMS_Remove;
    }
    this.filterRMSItems();
  }
  filterRMSItems() {
    const materialRMS = this.projectModel.generalInfo.materialRMS;

    if (materialRMS && Array.isArray(materialRMS)) {
      this.showDeleteRMSIcon = materialRMS.filter(x => x.status !== MaterialRMSConstants.MaterialRMS_Remove).length > 1;
    } else {
      this.showDeleteRMSIcon = false;
    }
  }


  // Method to find an item by materialRMSID and pop the item if materialRMSID = 0
  findOrRemoveRMSItem(inputItem: GinfoObjectiveProjectRMSVm): GinfoObjectiveProjectRMSVm | null {
    if (inputItem.materialRMSID === 0) {
      // Find the index of the item with materialRMSID = 0
      const index = this.projectModel.generalInfo.materialRMS.findIndex(item => item.materialRMSID === 0);

      // If the item is found, remove it from the list and return it
      if (index !== -1) {
        const removedItem = this.projectModel.generalInfo.materialRMS.splice(index, 1)[0];
        return removedItem;
      }

      return null;
    } else {
      // Find and return the item with the matching materialRMSID
      return this.projectModel.generalInfo.materialRMS.find(item => item.materialRMSID === inputItem.materialRMSID) || null;
    }
  }

  onChangeAddProductCategoryID(value: number | null | undefined) {
    this.selectedNewProductCategoryId = value;

  }


  // Function to check if at least one item has any of the specified properties empty or is true with empty newProductTitle
  hasEmptyRequiredPropertiesForNewProduct(products: ProductListManualVm[]): boolean {
    return products.some(product =>
      (!product.upc ||
        !product.vendorItemNumber || !product.newProductTitle) &&
      (product.isManuallyAddedNewProduct === true) && (product.isItRemove == false)
    );
  }

  // Function to assign selectedNewProductCategoryId to all items in productsManual using map
  assignCategoryToProducts(projectModel: ProjectVm) {
    // Check if productsManual is not null and selectedNewProductCategoryId is defined
    if (projectModel.productsManual && this.selectedNewProductCategoryId !== undefined) {
      projectModel.productsManual = projectModel.productsManual.map(product => ({
        ...product,
        categoryID: this.selectedNewProductCategoryId !== null
          ? this.selectedNewProductCategoryId
          : 0 // Explicitly set to undefined if null
      }));
    }
  }

  async loadProducts() {
    this.masterService.getProductsByCategories(this.allCategories).subscribe({
      next: (result) => {
        this.orgProductsList = []
        this.orgProductsList = result;
      },
      error: (error) => this.handleError('Error occurred while fetching products.', error),
    });
  }

  async getAddProjectResult(productsManual: ProductListManualVm[] | null): Promise<InstallationProductResultDto[]> {
    if (!productsManual || productsManual.length === 0) {
      return [];
    }

    const manuallyAddedNewProducts = productsManual
      .filter(x => x.isManuallyAddedNewProduct === true && x.productID === 0);

    const manuallyAddedProducts = productsManual
      .filter(x => x.isManuallyAddedNewProduct === true && x.productID !== undefined && x.productID > 0);


    const allProducts = this.orgProductsList;

    const lstInstallationProductResultDto: InstallationProductResultDto[] = [];

    // Process manually added new products
    if (manuallyAddedNewProducts.length > 0) {
      const newProductResults = manuallyAddedNewProducts
        .filter(product => product.vendorItemNumber)
        .map(manual => {
          const matchedProduct = allProducts.find(dto =>
            dto.vendorItemNumber?.trim().toLowerCase() === manual.vendorItemNumber?.trim().toLowerCase()
          );

          if (matchedProduct) {
            return {
              productDesc: manual.newProductTitle,
              itemNumber: manual.vendorItemNumber,
              upc: manual.upc
            };
          }
          return null;
        })
        .filter(result => result !== null) as InstallationProductResultDto[];

      lstInstallationProductResultDto.push(...newProductResults);
    }

    // Process manually added existing products
    if (manuallyAddedProducts.length > 0) {
      manuallyAddedProducts.forEach(item => {
        const product = allProducts.find(x => x.productID === item.productID);
        if (product && item.vendorItemNumber !== product.vendorItemNumber) {
          const existingProductResult = allProducts.find(dto =>
            dto.vendorItemNumber?.trim().toLowerCase() === item.vendorItemNumber?.trim().toLowerCase()
          );

          if (existingProductResult) {
            lstInstallationProductResultDto.push({
              productDesc: item.newProductTitle,
              itemNumber: item.vendorItemNumber,
              upc: item.upc
            });
          }
        }
      });
    }

    return lstInstallationProductResultDto;
  }

  private handleError(message: string, error: any): void {
    this.msgService.htmlError(message);
    this.errorLogService.logErrorNew(message, error);
    //this.ngxService.stop();
  }

  //// Ready for review changes 
  KeyValueChangesAfterReviewRequest(e: string) {
    if (this.ginfoKeyDatesComponent) {
      this.ginfoKeyDatesComponent.changeKeyDatesAfterReviewRequest(this.projectModel.generalInfo.projectDetails.headerId);
    }
  }

  ///validation criteria changes
  onUpdateValidationCriteria(event: ProjectValidationCriteria[]) {
    this.projectModel.projectValidationCriterias = event;
  }

  //// Call this ReadyForReview method to check validation before reviewing
  async ReadyForReview(e: string) {
    const isValidProjectData = await this.validateProjectData(true);
    if (isValidProjectData) {
      this.commonApprovalComponent!.readyForReviewClick();
    }
  }

  addItemReviewLogs() {
    if (this.hasProductItems) {
      // Show confirmation dialog to the user for Product Review
      this.confirmService.confirm({
        header: "Products Dialog",
        icon: 'pi pi-exclamation-triangle',
        message: "Have you reviewed the product items to ensure they are accurate?",

        accept: () => {
          let reviewLog = new ReviewLog();
          reviewLog.refID! = this.projectId!;
          reviewLog.type = this.refType;
          reviewLog.reviewedFor = 'Product';
          reviewLog.reviewedBy = this.uInfo?.userEmail;

          this.projectService.addItemReviewLogs(reviewLog).subscribe(x => {
            this.msgService.htmlSuccess("Product items are reviewed successfully");
            this.productReviewedBy = this.uInfo?.userEmail!;
            const currentDate = new Date();
            this.productReviewedDate = currentDate;
          });
        },
        reject: () => {
        }
      });
    }
  }

  showReminderDialog() {
    if (this.projectId > 0) {
      const project: ProjectDto = {
        projectID: this.projectId,
        vendorID: Number(this.vendorId),
        projectTitle: this.projectModel.generalInfo.projectDetails.projectTitle,
        projectType: RefTypeEnum.Project,
        actionItem: ActionItems.MATERIALS,
        userID: this.projectModel.generalInfo.projectDetails.ctRequester
      };

      this.emailService.open(this.selectedCategories, project);
    }
    else {
      this.msgService.htmlError(ProjectConstants.VALIDATION_REMINDER_EMAIL);
    }
  }

  getStoresToIdentify(
    allHawaiiStores: string | null | undefined,
    givenStores: string | null | undefined,
    identifiedStores: string | null | undefined
  ): string {
    // Default to empty arrays if inputs are null/undefined/empty
    const allHawaiiArr = (allHawaiiStores || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => s); // remove empty strings

    const givenArr = (givenStores || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => s);

    const identifiedArr = (identifiedStores || '')
      .split(',')
      .map(s => s.trim())
      .filter(s => s);

    if (!allHawaiiArr.length || !givenArr.length) {
      return ''; // nothing to match
    }

    // Filter to stores that are in given list & Hawaii list
    const matchingStores = givenArr.filter(store => allHawaiiArr.includes(store));

    //Remove any that are already identified
    const storesToIdentify = matchingStores.filter(store => !identifiedArr.includes(store));

    // Step 3: Return as comma-separated string
    return storesToIdentify.join(',');
  }

  //Get all stores in Hawaii state
  private getStoresByStates() {
    let selectedState = ["HI"];
    this.projectService.getStoresByStates(Number(this.vendorId), selectedState).subscribe(x => {
      this.selectedStoresByStates = x;
    });
  }

  onNotifyIsoAdmin(e: string) {

    if (this.projectId > 0) {

      const storeNumbers = e;

      const numbersArr = storeNumbers.split(',').map(x => x.trim());
      const storeDetails = this.selectedStoresByStates.filter(store => numbersArr.includes(store.storeNumber));

      this.projectModel.selectedStoresByStates = storeNumbers;

      const existingStores = this.projectModel.identifiedStores
        ? this.projectModel.identifiedStores.split(',').map(s => s.trim())
        : [];

      const newStores = storeNumbers.split(',').map(s => s.trim());

      // Merge and remove duplicates
      const updatedStores = Array.from(new Set([...existingStores, ...newStores]));

      const project: ProjectDto = {
        projectID: this.projectId,
        vendorID: Number(this.vendorId),
        projectTitle: this.projectModel.generalInfo.projectDetails.projectTitle,
        projectType: RefTypeEnum.Project,
        userID: this.projectModel.generalInfo.projectDetails.ctRequester,
        categoryList: this.selectedCategories,
        stores: storeDetails
      };

      const emailRequest: EmailRequestDto = {
        emailPurposeID: 6,
        purpose: EmailPurpose[6],
        toEmail: '',
        subject: '',
        placeholders: {},
        htmlBody: '',
        ccList: [],
        bccList: [],
        project: project,
        notes: storeNumbers
      };

      this.ngxService.start();

      this.emailService.sendEmail(emailRequest).pipe(
        finalize(() => {
          this.ngxService.stop();
        })
      ).subscribe(
        (isEmailSent: boolean) => {
          if (isEmailSent) {
            this.isNotifiedForStoreIdentificaion = true;
            this.projectModel.identifiedStores = updatedStores.join(', ');
            this.selectedIdentifiedStoreNumbers = updatedStores.join(', ');
            this.msgService.htmlSuccess(ProjectConstants.STORE_NOTIFICATION_MSG);
          } else {
            this.msgService.htmlError('Email could not be sent.');
          }
        },
        (error) => {
          this.msgService.htmlError('An error occurred while sending the email.');
        }
      );
    }
    else {
      this.msgService.htmlError(ProjectConstants.PROJECT_SALESPLAN_NOPROJECT);
      return;
    }
  }

  isAnyChangesOnStoreNumbers(existingStoreNumbers: string, currentStoreNumbers: string): boolean {
    if (!existingStoreNumbers && !currentStoreNumbers) {
      return false; // both empty → no change
    }

    const normalize = (stores: string) =>
      Array.from(
        new Set(
          (stores || '')
            .split(',')
            .map(s => s.trim())
            .filter(s => s) // remove empty strings
        )
      )
        .sort()
        .join(',');

    const normalizedExisting = normalize(existingStoreNumbers);
    const normalizedCurrent = normalize(currentStoreNumbers);

    return normalizedExisting !== normalizedCurrent;
  }

}
